import React, { Component, Fragment } from "react";
import { getAllowedSwitches } from "../../../../AssetTypeConfig/Reports/SwitchinspectionReport";
import { ReportGeneratorUtils } from "../../utils/reportGeneratorUtils";
import { switchReportStyle } from "../../Timps/Switch/style/index";
import { themeService } from "../../../../theme/service/activeTheme.service";
import _ from "lodash";
import ReportTitleSection from "../../../../libraries/ReportGenerator/ReportTitleSection";
import { tick_char } from "../../../jobBriefing/JobBrieifingReport/special-char";
import { dataFormatters } from "../../../../utils/dataFormatters";
import ReportInfoSection from "../../../../libraries/ReportGenerator/ReportInfoSection";
import { TickBox } from "../../../../libraries/ReportGenerator/TickBox";
import { EqualContentsRow } from "../../../../libraries/ReportGenerator/EqualContentsRow";
import { DataPropertyRow } from "../../../../libraries/ReportGenerator/DataPropertyRow";
import { EqualContentJustfy } from "../../../../libraries/ReportGenerator/EqualContentJustify";

const crossingTypesList = [
  "TIMBER",
  "TIMBER W/ MUD RAIL",
  "PAVED W/ RUBBER FW",
  "PAVED W/ MUD RAIL",
  "GRAVEL",
  "GRAVEL W/ MUD RAIL",
  "CONCRETE",
  "TIES",
  "STEEL RAIL",
  "FULL DEPTH RUBBER",
  "TIES W/ MUD RAIL",
  "OTHER",
];

const sightLinesOptions = ["CLEAR", "OBSTRUCTED", "BRUSH", "OTHER"];
const structureConditionOptions = ["EXCELLENT", "GOOD", "FAIR", "POOR", ""];
const mudrailTypeOptions = ["STEEL", "RUBBER", "NONE", "", ""];
const flangewayConditionOptions = ["CLEAR", "CLOGGED", "", "", ""];
const guageMeasurementOptions = ["56 ½''", "OTHER", ""];
const yesNoOptions = ["", "YES", "NO", "", ""];
const signageConditionOptions = ["GOOD", "DAMAGED", "MISSING", "N/A", ""];

const SectionHeader = ({ title }) => {
  return <div className={"section-header-a"}>{title}</div>;
};

class ReportView extends Component {
  render() {
    let reportData = this.props.reportData ? this.props.reportData : {};
    let { milepost, location, user, date, formSummary, subdivision } = reportData;
    if (!formSummary) formSummary = {};

    let data = {
      lineName: subdivision,
      location: location,
      user: user ? user.name : "",
      milepost: milepost,
      reportDate: dataFormatters.dateFormatter(date),
      ...formSummary,
    };

    return (
      <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
        <ReportTitleSection
          title={`Annual Inspection of Private or Public Crossings (Detailed)`}
          displayRevisedAreaText={"Revised: October 14, 2021"}
          fontSizeOverride={"26px"}
        />
        <ReportInfoSection
          fontSizeOverride={"18px"}
          rows={[
            {
              col1: {
                title: "DATE",
                value: data.reportDate,
              },
              col2: {
                title: "INSPECTOR",
                value: data.user,
              },
            },
            {
              col1: {
                title: "LOCATION",
                value: data.location,
              },
              col2: {
                title: "SUBDIVISION",
                value: data.lineName,
              },
            },
            {
              col1: {
                title: "MILEAGE",
                value: data.milepost,
              },
            },
          ]}
        />

        <SectionHeader title={"GENERAL INFORMATION"} />
        <EqualContentsRow>
          <div style={{ fontWeight: 600 }}>CROSSING DESIGNATION</div>
          <TickBox flag={data.cdesig === "PUBLIC"} label={"PUBLIC"} />
          <TickBox flag={data.cdesig === "PRIVATE"} label={"PRIVATE"} />
          <div></div>
        </EqualContentsRow>
        <EqualContentsRow>
          <div style={{ fontWeight: 600 }}>CROSSING PROTECTION</div>
          <TickBox flag={data.cprot === "LIGHTS"} label={"LIGHTS"} />
          <TickBox flag={data.cprot === "CROSSBUCKS"} label={"CROSSBUCKS"} />
          <div></div>
        </EqualContentsRow>
        <SectionHeader title={"CROSSING TYPE"} />
        <EqualContentJustfy>
          {crossingTypesList.map((val) => (
            <TickBox flag={data.ctype === val} label={val} style={{ flex: "1 0 21%" }} otherVal={data.topen} />
          ))}
        </EqualContentJustfy>

        <SectionHeader title={"SIGHTLINES"} />

        <DataPropertyRow title={"NORTH-EAST QUADRANT"} id={"nequad"} data={data} options={sightLinesOptions} otherValId={"topen1"} />
        <DataPropertyRow title={"NORTH-WEST QUADRANT"} id={"nwquad"} data={data} options={sightLinesOptions} otherValId={"topen2"} />
        <DataPropertyRow title={"SOUTH-EAST QUADRANT"} id={"sequad"} data={data} options={sightLinesOptions} otherValId={"topen3"} />
        <DataPropertyRow title={"SOUTH-WEST QUADRANT"} id={"swquad"} data={data} options={sightLinesOptions} otherValId={"topen4"} />

        <SectionHeader title={"STRUCTURE"} />
        <DataPropertyRow title={"MUDRAIL TYPE"} id={"mtype"} data={data} options={mudrailTypeOptions} />
        <DataPropertyRow title={"MUDRAIL CONDITION"} id={"mcond"} data={data} options={structureConditionOptions} />
        <DataPropertyRow title={"FLANGEWAY CONDITION"} id={"flang"} data={data} options={flangewayConditionOptions} />
        <DataPropertyRow title={"BALLAST & DRAINAGE"} id={"balast"} data={data} options={structureConditionOptions} />
        <DataPropertyRow title={"LINE CONDITION"} id={"line"} data={data} options={structureConditionOptions} />
        <DataPropertyRow title={"SURFACE CONDITION"} id={"surf"} data={data} options={structureConditionOptions} />
        <DataPropertyRow title={"TIE CONDITION"} id={"condit"} data={data} options={structureConditionOptions} />
        <DataPropertyRow title={"RAIL CONDITION"} id={"rcondit"} data={data} options={structureConditionOptions} />
        <EqualContentsRow>
          <div style={{ fontWeight: 600, flexGrow: 2 }}>GAUGE MEASUREMENTS</div>
          {[
            { key: "MIN", id: "gmeasmin" },
            { key: "MAX", id: "gmeasmax" },
          ].map((property) => {
            const { key, id } = property;
            return <TickBox forceOther={true} flag={data.hasOwnProperty(id)} label={key} otherVal={data[id]} style={{ flexGrow: 2 }} />;
          })}
          <div></div>
        </EqualContentsRow>
        <DataPropertyRow title={"INSULATED JOINT CONDITION"} id={"insult"} data={data} options={structureConditionOptions} />
        <DataPropertyRow
          title={"ROAD APPROACHES"}
          titlePostComp={
            <div style={{ fontSize: "14px", fontWeight: "normal", fontStyle: "italic", textDecoration: "underline" }}>
              {"(for private crossings - entire RoW)"}
            </div>
          }
          id={"priv"}
          data={data}
          options={structureConditionOptions}
        />

        <SectionHeader title={"SIGNAGE"} />
        <DataPropertyRow title={"MILEAGE IDENTIFIED AT CROSSING"} id={"miller"} data={data} options={yesNoOptions} />
        <DataPropertyRow title={"CROSSBUCK CONDITION"} id={"croscon"} data={data} options={signageConditionOptions} />
        <DataPropertyRow title={"# OF TRACKS CONDITION"} id={"notar"} data={data} options={signageConditionOptions} />
        <DataPropertyRow title={"REFLECTIVE TAPE"} id={"reflect"} data={data} options={signageConditionOptions} />
        <DataPropertyRow title={"ENS CONDITION"} id={"ens"} data={data} options={signageConditionOptions} />
        <DataPropertyRow title={"STOP SIGN CONDITION"} id={"ssco"} data={data} options={signageConditionOptions} />
        <DataPropertyRow title={"FLANGER MARKERS"} id={"marky"} data={data} options={signageConditionOptions} />
        <DataPropertyRow title={"WHISTLE POST"} id={"wpost"} data={data} options={signageConditionOptions} />

        <SectionHeader title={"COMMENTS"} />

        <div style={{ border: "2px solid", padding: "5px", fontSize: "18px", height: "100px" }}>{data.com}</div>
      </div>
    );
  }
}

const ONR_DetailedAnnualInspectionOfPrivatePublicAssetsReport = (props) => {
  const { inspec, isPreview } = props;
  if (isPreview) {
    return <ReportView reportData={{}} isPreview={true} />;
  }

  let assets = ReportGeneratorUtils.getInspectionAssetsWithForm(inspec, () => true, "onrDetAnnInspectionPriPubAssetForm");

  return assets.map((asset, _i) => (
    <ReportView
      key={_i}
      {...props}
      reportData={{
        formSummary: asset.summary,
        location: asset.assetName,
        subdivision: ReportGeneratorUtils.getInspectionSubdivision(inspec),
        date: ReportGeneratorUtils.getInspectionDate(inspec),
        user: ReportGeneratorUtils.getInspectionUser(inspec),
        milepost: asset.milepost,
      }}
    />
  ));
};

export default ONR_DetailedAnnualInspectionOfPrivatePublicAssetsReport;



// WEBPACK FOOTER //
// ./src/components/Reports/ONR/DetailedAnnualInspectionOfPrivatePublicAssetsReport/index.jsx